
import { FieldControl } from '@signature-it/ngx-generic/enums';
import { SelectField } from "./select";

export class MultiSelectGroupsField extends SelectField {
    controlType = FieldControl.MULTI_SELECT_GROUPS;
    openPopup = true;
    selectOptionsTitle: string;

    constructor(attributes?: Object) {
        super(attributes);
        this.selectOptionsTitle = attributes['selectOptionsTitle'] || this.fieldLabel;
    }
}
